import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

// Types
// import { UpdateAiTemplate } from '../types';
import { UpdateAiTemplateType, IntegrationSources } from 'Shared/types/UpdateAiTemplate.type';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';

// Coonstants
import { InputSources } from '../InputSources.constants';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Actions
import { createUpdateAiSetting } from 'Shared/actions/UpdateAiSettings.actions';

// Components
import { WpContainer, WpContainerBody, WpContainerFooter } from 'Wpds/components/container';
import { WpButton } from 'Wpds/components/button';
import { WpBadge, WpBadgeList } from 'Wpds/components/badge';
import WpLabelled from 'Wpds/components/labelled/WpLabelled';

// Styles
import './UpdateAiTempalteItem.scss';

type Props = {
  template: UpdateAiTemplateType;
};

const UpdateAiTempalteItem = ({ template }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [isCreating, toggleIsCreating] = useToggle(false);

  const requiresIntegrations = template.defaultDataSourceSlugs?.length > 0;

  const handleChooseTemplate = () => {
    toggleIsCreating();

    dispatch(createUpdateAiSetting({ templateType: template.templateType })).then(response => {
      if (response.status === 200) {
        history.push(PageUrlsUtil.makeUpdateAiSettingPageUrl({ slug: response.data.data.attributes.slug }));
      }
    });
  };

  const getIntegrationName = (source: IntegrationSources) => {
    return InputSources.find(src => src.id === source).name;
  };

  const getIntegrationLogo = (source: IntegrationSources) => {
    return InputSources.find(src => src.id === source).logo;
  };

  const baseClassName = 'UpdateAiTempalteItem';

  return (
    <WpContainer className={baseClassName}>
      <WpContainerBody>
        <h5>{template.name}</h5>
        <p className={`${baseClassName}__description`}>{template.description}</p>
        {requiresIntegrations && (
          <WpLabelled
            id="integration"
            label="Requires at least one of the following integrations:"
            showRequiredIndicator={false}
          >
            <WpBadgeList>
              {template.defaultDataSourceSlugs.map(integration => (
                <WpBadge key={integration} variant="outline" size="lg" className={`${baseClassName}__badge`}>
                  <img className={`${baseClassName}__badge__logo`} src={getIntegrationLogo(integration)} />
                  {getIntegrationName(integration)}
                </WpBadge>
              ))}
            </WpBadgeList>
          </WpLabelled>
        )}
      </WpContainerBody>
      <WpContainerFooter justifyContent="flexEnd">
        <WpButton variant="tertiary" onClick={handleChooseTemplate} loading={isCreating}>
          Choose template
        </WpButton>
      </WpContainerFooter>
    </WpContainer>
  );
};

export default UpdateAiTempalteItem;
